import React from 'react';

import { NewEmail } from '@/components/emailWindow/components/newEmail/NewEmail.comp.tsx';
import { useNewEmailIsFloatingWindow } from '@/views/emails/context/NewEmails.ts';

export const EmailWindow: React.FC = () => {
  const isFloatingWindow = useNewEmailIsFloatingWindow();

  if (!isFloatingWindow) {
    return null;
  }
  return <NewEmail />;
};
